import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Projects = ({ t }) => {
  const [photos, setPhotos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/photos`)
      .then((r) => setPhotos(r.data || []))
      .catch(() => setPhotos([]));
  }, []);

  if (!photos.length) return null;

  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="py-24 md:py-40 border-t border-[#183321]/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12 md:mb-16">
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#183321]/40" />
              <span className="text-xs uppercase tracking-[0.25em] text-[#4A6B53] font-semibold">
                {t.projects.eyebrow}
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#183321] font-medium">
              {t.projects.title}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-base md:text-lg leading-relaxed text-[#4A6B53]">
              {t.projects.sub}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {photos.map((p, idx) => (
            <button
              key={p.id}
              data-testid={`project-photo-${idx}`}
              onClick={() => setActive(p)}
              className="group text-left bg-[#FDFDF9] border border-[#183321]/10 rounded-sm overflow-hidden hover:-translate-y-1 hover:shadow-[0_24px_40px_-24px_rgba(24,51,33,0.25)] transition-all duration-500"
            >
              <div className="aspect-[4/3] overflow-hidden bg-[#EAF1E8]">
                <img
                  src={p.image_url}
                  alt={p.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-serif text-xl md:text-2xl text-[#183321] leading-tight">
                    {p.title}
                  </h3>
                  <ArrowUpRight
                    size={18}
                    className="shrink-0 text-[#183321]/40 group-hover:text-[#C26D5C] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                  />
                </div>
                {p.caption && (
                  <p className="text-sm text-[#4A6B53] mt-2 line-clamp-2">
                    {p.caption}
                  </p>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {active && (
        <div
          data-testid="project-lightbox"
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[100] bg-[#183321]/90 backdrop-blur-sm flex items-center justify-center p-6 cursor-zoom-out"
        >
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={active.image_url}
              alt={active.title}
              className="w-full max-h-[80vh] object-contain rounded-sm"
            />
            <div className="mt-4 text-[#FDFDF9]">
              <div className="font-serif text-2xl">{active.title}</div>
              {active.caption && (
                <div className="text-sm text-[#FDFDF9]/70 mt-1">
                  {active.caption}
                </div>
              )}
            </div>
            <button
              onClick={() => setActive(null)}
              className="mt-6 px-5 py-2 border border-[#FDFDF9]/30 text-[#FDFDF9] text-xs uppercase tracking-widest hover:bg-[#FDFDF9] hover:text-[#183321] transition-all rounded-sm"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};
